export default "__VITE_ASSET__12bd7b3f__"